module.exports = __webpack_public_path__ + "img/logistic-network-embargo.44b0b400.png";